import { T } from "react-translator-component";
import { paymentTypes } from "../constants/payments"

export const dispPayUserType = (type: string) => {
  switch (type) {
    case "User" :
      return T("mng_payment_person_type_user")
    case "MemberGroup" :
      return T("mng_payment_person_type_membergroup")
    case "Shop" :
      return T("mng_payment_person_type_shop")
    default :
      return ""
  }
}

export const dispPaymentType = (paymentType: any) => {
  if (!paymentTypes.includes(paymentType)) return ""

  return T(`mng_payment_type_${paymentType.toLocaleLowerCase()}`)
}
